/*-------------------------------------------------------------------
グローバル変数
--------------------------------------------------------------------*/
let headerHeight;

function getHeaderHeight() {
  const header = document.querySelector('.js-header');
  return header ? header.offsetHeight : 0;
}

/*-------------------------------------------------------------------
関数定義
--------------------------------------------------------------------*/
function isPc() {
  return window.innerWidth >= 768;
}
// Mobileの場合True
function isMobile() {
  return !isPc();
}

/**
 * 指定の要素のテキストを1文字ずつspanで囲む
 */
const wrapSpan = () => {
  const textWrap = document.querySelectorAll('.js-wrapSpan');
  textWrap.forEach((t) => (
    t.innerHTML = t.textContent.replace(/\S/g, '<span>$&</span>')
  ));
}

/**
 * スムーススクロール共通処理
 * @param {string} targetId - スクロール先のセレクタ
 * @param {number} speed - アニメーション速度（デフォルト: 500）
 * @param {number} offset - オフセット値（デフォルト: headerHeight）
 */
function smoothScrollTo(targetId, speed = 500, offset = null) {
  const target = jQuery(targetId);
  if (!target.length) return;

  let position = target.offset().top;
  const adjustOffset = offset !== null ? offset : headerHeight;

  // ヘッダーの固定状態に応じて位置を調整
  if (("fixed" === jQuery("#header").css("position")) || ("sticky" === jQuery("#header").css("position"))) {
    position -= adjustOffset;
  }

  // 負の値にならないようにする
  if (position < 0) {
    position = 0;
  }

  jQuery("html, body").animate({ scrollTop: position }, speed);
}

/**
 * アンカーリンク
*/
function scrollHash() {
  // リロード（開発中のライブリロード含む）では現在のスクロール位置を維持する
  const navEntry = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
  const isReload = navEntry
    ? navEntry.type === 'reload'
    : (performance.navigation && performance.navigation.type === 1);
  if (isReload) return;

  const hash = location.hash;
  if (hash && jQuery(hash).length) {
    // 一旦トップに戻してから目的地にスクロール
    window.scrollTo(0, 0);
    setTimeout(() => {
      smoothScrollTo(hash, 500);
    }, 300);
  }
}


// /**
//  * ローディング画面
//  */
// function stopload() {
//   jQuery('#js-loading').delay(900).fadeOut(800);
// }

/*-------------------------------------------------------------------
読み込み時実行
--------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  headerHeight = getHeaderHeight();
  // wrapSpan();
  // setTimeout('stopload()', 10000);
});


/*-------------------------------------------------------------------
イベント
--------------------------------------------------------------------*/
/**
 * スクロールバーを除いた画面幅の取得
 */
jQuery(window).on('load resize', function () {
  let vw = document.body.clientWidth;// スクロールバーを除いた幅を取得
  let vh = window.innerHeight; // アドレスバーを覗いた画面高さ
  headerHeight = getHeaderHeight();
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vw-unitless', `${vw}`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
});


// ローディング判定
jQuery(window).on("load", function () {
  jQuery("body").attr("data-loading", "true");
  // stopload();
});

/**
 * フェードしたページに戻るときに白飛びする対応
 */
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});

jQuery(function () {
  // ページロード完了後にスクロールハッシュを実行
  jQuery(window).on('load', function() {
    scrollHash();
  });
  // gsap.to('body', { opacity: 1, duration: 0.5 });

  // 画面遷移
  window.addEventListener('beforeunload', function (e) {
    document.body.classList.add("fadeOut");
    setTimeout(() => {
      window.location = url;
    }, 500);
  });

  // スクロール判定
  jQuery(window).on("scroll", function () {
    let scrollTop = jQuery(this).scrollTop();
    let windowHeight = jQuery(this).height();
    let documentHeight = jQuery(document).height();

    if (100 < scrollTop) {
      jQuery("body").attr("data-scroll", "true");
    } else {
      jQuery("body").attr("data-scroll", "false");
    }

    const isAtBottom = documentHeight - (windowHeight + scrollTop) <= 0;

    if (isAtBottom) {
      jQuery("body").attr("data-scroll-bottom", "true");
    } else {
      jQuery("body").attr("data-scroll-bottom", "false");
    }

    /**
     * トップに戻るボタン（FVを過ぎたら表示）
     */
    const totop = jQuery('.js-totop');
    if (totop.length) {
      const $fv = jQuery('.p-fv');
      const fvBottom = $fv.length ? $fv.offset().top + $fv.outerHeight() : windowHeight;
      totop.toggleClass('is-active', scrollTop > fvBottom);
    }

  });

  /* ドロワー */
  jQuery(".js-drawer").on("click", function (event) {
    event.preventDefault();
    const ariaControls = jQuery(this).attr("aria-controls");
    const addClass = 'is-opened'

    if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
      jQuery(`#${ariaControls}`).removeClass(addClass);
    } else {
      jQuery(`#${ariaControls}`).addClass(addClass);
    }

    jQuery(`[aria-controls=${ariaControls}]`).each(function () {
      jQuery(this).attr("aria-expanded", (jQuery(`#${ariaControls}`).hasClass(addClass) ? 'false' : 'true'));
      if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
        jQuery(this).addClass(addClass);
      } else {
        jQuery(this).removeClass(addClass);
      }
    });

    // ドロワー開時にbody要素がスクロールしないように
    (jQuery(`#${ariaControls}`).hasClass(addClass) ? jQuery('body').addClass('u-overflowHidden') : jQuery('body').removeClass('u-overflowHidden'));

    return false;
  });

  /**
   * ドロワー内のページ内リンククリック時に閉じる
   */
  jQuery('#drawer-content1 a[href*="#"]').on('click', function (event) {
    const currentUrl = location.protocol + '//' + location.host + location.pathname; // 現在のURL
    const href = jQuery(this).prop("href");
    const hrefUrl = href.split('#')[0];   // リンク先のURL

    if (currentUrl == hrefUrl) {
      jQuery('.for-drawer').removeClass('is-opened');
      jQuery('#drawer-content1').attr('aria-hidden', true);
      jQuery('body').removeClass('u-overflowHidden');
    }
  });

  /* ヘッダ */
  jQuery(window).on('load scroll', function () {
    // if (jQuery('body').hasClass('home')) {
    const $header = jQuery('.js-header');
    if ($header.length) {
      const target = jQuery(`.${jQuery($header).data('target')}`);
      const targetHeight = (target.length ? target.innerHeight() : headerHeight * 1.1);
      let position = jQuery(this).scrollTop();
      if (position > targetHeight) {
        $header.addClass('is-fixed');
      } else if (position == 0) {
        $header.removeClass('is-fixed');
      }
    }
    // }
  });


  /* スムーススクロール */
  jQuery(document).on('click', 'a[href*="#"]:not(".js-tabIndex, .js-modal, .js-accordion, .toc_toggle a")', function (e) {
    const currentUrl = location.protocol + '//' + location.host + location.pathname.replace(/\/$/, ''); // 現在のURL
    const href = jQuery(this).prop("href");
    const hrefUrl = href.split('#')[0].replace(/\/$/, '');   // リンク先のURL

    if (currentUrl == hrefUrl) {
      e.preventDefault();
      let id = '#' + href.split('#')[1];  // リンク先のアンカー
      const targetId = "#" === id ? "html" : id;
      smoothScrollTo(targetId, 500);
      jQuery(this).blur();
    }
  });

  /* 電話リンク */
  let $ua = navigator.userAgent;
  if ($ua.indexOf("iPhone") < 0 && $ua.indexOf("Android") < 0) {  // PCのとき
    jQuery('a[href^="tel:"]') // 電話リンク
      .css("cursor", "default") // カーソルをポインターにしない
      .css('pointer-events', 'none')  // ホバーなども動作しない
      .on("click", function (e) {
        e.preventDefault();
      });
  }

  /* tab */
  jQuery('.js-tabIndex').on('click', function (e) {
    e.preventDefault();
    const tabParent = jQuery(this).parents('.js-tab');
    const targets = jQuery(this).data('target');
    const target = jQuery(this).attr('href');

    jQuery('.js-tabIndex.is-active').removeClass('is-active');
    jQuery(this).addClass('is-active');

    // 現在表示しているものを非表示にする
    tabParent.find(`.${targets}.is-active`).removeClass('is-active');
    // クリックしたタブのターゲットを表示
    jQuery(target).addClass('is-active');

    return false;
  });

  /* アコーディオン */
  jQuery(document).on('click', '.js-accordion-trigger', function (e) {
    e.preventDefault();
    const $trigger = jQuery(this);
    const $item = $trigger.closest('.c-accordion__item');
    const $panel = $item.find('.c-accordion__panel');
    const isExpanded = $trigger.attr('aria-expanded') === 'true';

    $trigger.attr('aria-expanded', isExpanded ? 'false' : 'true');
    $panel.attr('aria-hidden', isExpanded ? 'true' : 'false');
    $item.toggleClass('is-open', !isExpanded);
  });

  /* モーダル */
  jQuery('.js-modal-open').on('click', function (e) {
    e.preventDefault();
    const modalId = jQuery(this).data('modal');
    const $modal = jQuery(`#${modalId}`);

    if (!$modal.length) return;

    $modal.addClass('is-open').attr('aria-hidden', 'false');
    jQuery('body').addClass('u-overflowHidden');
  });

  jQuery(document).on('click', '.js-modal-close', function () {
    const $modal = jQuery(this).closest('.js-modal');

    $modal.removeClass('is-open').attr('aria-hidden', 'true');
    jQuery('body').removeClass('u-overflowHidden');
  });

  /* 実績モーダル：クリックしたカードの内容を流し込んで表示 */
  let $lastWorkCard = null;

  const openWorksModal = function ($card) {
    const $worksModal = jQuery('#worksModal');
    if (!$worksModal.length) return;

    const title = $card.find('.p-works__cardTitle').text();
    const url = $card.data('url');

    const $cardBadge = $card.find('.p-works__thumbBadge');
    $worksModal.find('.js-worksModalBadge')
      .text($cardBadge.text())
      .css('background-color', $cardBadge.css('background-color')); // カードのバッジ色に合わせる
    $worksModal.find('.js-worksModalImg').attr('src', $card.find('.p-works__thumbImg').attr('src')).attr('alt', title);
    $worksModal.find('.js-worksModalTitle').text(title);

    // 詳細説明があればそれを、無ければカードの説明文を表示
    const $detail = $card.find('.p-works__detail');
    const $modalText = $worksModal.find('.js-worksModalText');
    if ($detail.length && jQuery.trim($detail.html())) {
      $modalText.html($detail.html());
    } else {
      $modalText.empty().append(jQuery('<p></p>').text($card.find('.p-works__cardText').text()));
    }

    const $link = $worksModal.find('.js-worksModalLink');
    if (url) {
      $link.attr('href', url).css('display', '');
    } else {
      $link.css('display', 'none');
    }

    $worksModal.addClass('is-open').attr('aria-hidden', 'false');
    jQuery('body').addClass('u-overflowHidden');
    $worksModal.find('.js-modal-close').last().trigger('focus');
  };

  jQuery(document).on('click', '.js-workCard', function () {
    $lastWorkCard = jQuery(this);
    openWorksModal($lastWorkCard);
  });

  jQuery(document).on('keydown', '.js-workCard', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      $lastWorkCard = jQuery(this);
      openWorksModal($lastWorkCard);
    }
  });

  // 閉じたらカードへフォーカスを戻す
  jQuery(document).on('click', '#worksModal .js-modal-close', function () {
    if ($lastWorkCard) $lastWorkCard.trigger('focus');
  });

  // Escで閉じる
  jQuery(document).on('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const $open = jQuery('#worksModal.is-open');
    if (!$open.length) return;
    $open.removeClass('is-open').attr('aria-hidden', 'true');
    jQuery('body').removeClass('u-overflowHidden');
    if ($lastWorkCard) $lastWorkCard.trigger('focus');
  });

  /* 実績カテゴリタブ（絞り込み）＋ もっと見る */
  const $worksFilter = jQuery('.js-worksFilter');

  if ($worksFilter.length) {
    const WORKS_STEP = 4; // 初期表示件数
    let worksFilterKey = 'all';
    let worksLimit = WORKS_STEP;
    const $moreWrap = jQuery('.js-worksMoreWrap');

    // 各カテゴリの件数を数えてタブに表示
    const counts = { all: 0 };
    jQuery('.js-workCard').each(function () {
      const cat = jQuery(this).data('category');
      counts.all += 1;
      counts[cat] = (counts[cat] || 0) + 1;
    });
    $worksFilter.find('.p-works__filterBtn').each(function () {
      const filter = jQuery(this).data('filter');
      jQuery(this).find('.p-works__filterCount').text('(' + (counts[filter] || 0) + ')');
    });

    // 現在のフィルタ・表示上限に合わせてカードと「もっと見る」を更新
    const applyWorks = function () {
      let shown = 0;
      jQuery('.js-workCard').each(function () {
        const match = worksFilterKey === 'all' || jQuery(this).data('category') === worksFilterKey;
        let visible = false;
        if (match) {
          visible = shown < worksLimit;
          if (visible) shown += 1;
        }
        jQuery(this).toggleClass('is-hidden', !visible);
      });

      const total = counts[worksFilterKey] || 0;
      const remaining = total - Math.min(worksLimit, total);
      if ($moreWrap.length) {
        if (remaining > 0) {
          $moreWrap.find('.p-works__moreCount').text('（残り' + remaining + '件）');
          $moreWrap.removeClass('is-hidden');
        } else {
          $moreWrap.addClass('is-hidden');
        }
      }
    };

    // タブクリックで絞り込み（上限はリセット）
    jQuery(document).on('click', '.js-worksFilter .p-works__filterBtn', function () {
      worksFilterKey = jQuery(this).data('filter');
      worksLimit = WORKS_STEP;
      jQuery(this).addClass('is-active').attr('aria-selected', 'true')
        .siblings().removeClass('is-active').attr('aria-selected', 'false');
      applyWorks();
    });

    // もっと見る：現在のフィルタを全件表示
    jQuery(document).on('click', '.js-worksMore', function () {
      worksLimit = counts[worksFilterKey] || worksLimit;
      applyWorks();
    });

    applyWorks();
  }
});
